import Cookies from 'js-cookie';

class ClearCache {
  constructor() {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="ClearCache"]')
    };
  }

  init() {
    const { moduleList } = this.config;

    moduleList.forEach(module => {
      module.addEventListener('click', e => {
        e.preventDefault();

        const token = Cookies.get('token');

        if (!token) {
          return;
        }

        fetch('/api/v1/cache/clear', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(res => {
          if (res.status === 200) {
            document.location.reload();
          }
        });
      });
    });
  }
}

export default ClearCache;
